import { render, staticRenderFns } from "./SWTimeSheet.vue?vue&type=template&id=564a2882&"
import script from "./SWTimeSheet.vue?vue&type=script&lang=ts&"
export * from "./SWTimeSheet.vue?vue&type=script&lang=ts&"
import style0 from "./SWTimeSheet.vue?vue&type=style&index=0&id=564a2882&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
